import { css } from 'styled-components/macro';
import { iconNames } from '@blueprint/icons';

const cssToogleIconState = (iconName, psuedoStates) =>
  iconNames[`${iconName}Active`] &&
  css`
    ${`&:${psuedoStates.join(',&:')}`} ,&.focus-visible {
      [data-id='ActiveIcon'] {
        visibility: visible;
        opacity: 1;
        top: 0;
      }

      [data-id='Icon'] {
        visibility: hidden;
        opacity: 0;
      }
    }

    &:focus-visible {
      [data-id='ActiveIcon'] {
        visibility: visible;
        opacity: 1;
        top: 0;
      }

      [data-id='Icon'] {
        visibility: hidden;
        opacity: 0;
      }
    }
  `;

export default cssToogleIconState;
